import React from "react";
import Lottie from "lottie-react";
import Header2 from "../Header2/Header2";
import Footer2 from "../Footer2/Footer2";
import "./gestionadministrativa.css";

// Animaciones
import adminAnim from "../../Assets/Animations/Staff.json";
import recordsAnim from "../../Assets/Animations/Review.json";
import attendanceAnim from "../../Assets/Animations/Service.json";
import enrollmentAnim from "../../Assets/Animations/History.json";
import promotionAnim from "../../Assets/Animations/Follow Us.json";
import organizationAnim from "../../Assets/Animations/Establish.json";
import dashboardAnim from "../../Assets/Animations/dashboard.json";

function GestionAdministrativa() {
  return (
    <>
      <Header2 />
      <section className="gestion-section">

        {/* Fondo decorativo */}
        <div className="gestion-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>

        {/* HERO GESTIÓN ADMINISTRATIVA */}
        <div className="gestion-hero">
          <div className="gestion-hero-content">

            {/* Contenido textual */}
            <div className="gestion-hero-text">
              <span className="gestion-badge">
                <i className='bx bx-buildings'></i>
                Gestión administrativa escolar
              </span>

              <h1 className="gestion-title">
                La gestión institucional,
                <span className="title-highlight"> clara y ordenada</span>
              </h1>

              <p className="gestion-subtitle">
                Centralizá la información académica y administrativa
                de tu institución en un solo sistema, sin planillas
                dispersas ni procesos manuales.
              </p>

              {/* Stats de gestión */}
              <div className="gestion-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className='bx bx-time-five'></i>
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">-60%</span>
                    <span className="stat-label">Tiempo en tareas repetitivas</span>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className='bx bx-trending-up'></i>
                  </div>
                  <div className="stat-content">
                    <span className="stat-number">+90%</span>
                    <span className="stat-label">Precisión de datos</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Icono animado con contenedor especial */}
            <div className="gestion-icon-container">
              <div className="icon-wrapper">
                <Lottie
                  animationData={adminAnim}
                  loop
                  className="gestion-main-anim"
                />
                <div className="icon-glow"></div>
              </div>
              <div className="icon-orbits">
                <div className="orbit orbit-1">
                  <i className='bx bx-file'></i>
                </div>
                <div className="orbit orbit-2">
                  <i className='bx bx-user-check'></i>
                </div>
                <div className="orbit orbit-3">
                  <i className='bx bx-chart'></i>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* VISIÓN INTEGRAL */}
        <div className="gestion-vision">
          <div className="vision-container">
            <div className="vision-icon">
              <Lottie animationData={dashboardAnim} loop />
            </div>
            <div className="vision-content">
              <h3 className="vision-title">
                Un solo panel para toda la gestión institucional
              </h3>
              <p className="vision-description">
                TRESA integra todas las áreas administrativas en una única plataforma,
                eliminando la fragmentación de datos y procesos.
              </p>
              <div className="vision-tags">
                <span className="vision-tag">Centralizado</span>
                <span className="vision-tag">Integrado</span>
                <span className="vision-tag">Auditable</span>
              </div>
            </div>
          </div>
        </div>

        {/* GRID DE GESTIÓN MEJORADO */}
        <div className="gestion-grid-section">
          <div className="section-header">
            <h2>
              Cada aspecto administrativo,
              <span> optimizado y simple</span>
            </h2>
            <p>
              Herramientas específicas para cada necesidad de gestión,
              diseñadas desde la realidad institucional.
            </p>
          </div>

          <div className="gestion-grid">

            {/* Trayectorias escolares */}
            <div className="gestion-card">
              <div className="card-icon">
                <Lottie animationData={recordsAnim} loop />
              </div>
              <div className="card-content">
                <h4>Trayectorias escolares</h4>
                <p>
                  Seguimiento completo del recorrido académico de cada
                  estudiante, con información siempre actualizada.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Historial académico</li>
                  <li><i className='bx bx-check'></i> Evolución por periodo</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Seguimiento integral</span>
              </div>
            </div>

            {/* Expedientes digitales */}
            <div className="gestion-card">
              <div className="card-icon">
                <i className='bx bx-folder-open'></i>
              </div>
              <div className="card-content">
                <h4>Expedientes digitales</h4>
                <p>
                  Toda la documentación institucional organizada,
                  accesible y protegida desde un único lugar.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Documentación segura</li>
                  <li><i className='bx bx-check'></i> Acceso por roles</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Documentación 100% digital</span>
              </div>
            </div>

            {/* Asistencias y calificaciones */}
            <div className="gestion-card">
              <div className="card-icon">
                <Lottie animationData={attendanceAnim} loop />
              </div>
              <div className="card-content">
                <h4>Asistencias y calificaciones</h4>
                <p>
                  Registro simple y claro de asistencias, evaluaciones
                  y calificaciones por curso y cohorte.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Registro en tiempo real</li>
                  <li><i className='bx bx-check'></i> Reportes automáticos</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Control académico</span>
              </div>
            </div>

            {/* Inscripciones automatizadas */}
            <div className="gestion-card">
              <div className="card-icon">
                <Lottie animationData={enrollmentAnim} loop />
              </div>
              <div className="card-content">
                <h4>Inscripciones automatizadas</h4>
                <p>
                  Procesos de inscripción ordenados, ágiles y
                  sin carga administrativa innecesaria.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Formularios digitales</li>
                  <li><i className='bx bx-check'></i> Confirmación automática</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Procesos optimizados</span>
              </div>
            </div>

            {/* Cohortes y cursos */}
            <div className="gestion-card">
              <div className="card-icon">
                <Lottie animationData={organizationAnim} loop />
              </div>
              <div className="card-content">
                <h4>Cohortes y cursos</h4>
                <p>
                  Creación y organización de cohortes, divisiones
                  y cursos según la estructura institucional.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Configuración flexible</li>
                  <li><i className='bx bx-check'></i> Jerarquía institucional</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Organización académica</span>
              </div>
            </div>

            {/* Promoción de estudiantes */}
            <div className="gestion-card">
              <div className="card-icon">
                <Lottie animationData={promotionAnim} loop />
              </div>
              <div className="card-content">
                <h4>Promoción de estudiantes</h4>
                <p>
                  Gestión clara de promociones, pases de año
                  y cambios de estado académico.
                </p>
                <ul className="card-features">
                  <li><i className='bx bx-check'></i> Reglas configurables</li>
                  <li><i className='bx bx-check'></i> Procesos validados</li>
                </ul>
              </div>
              <div className="card-footer">
                <span className="card-tag">Gestión de promociones</span>
              </div>
            </div>

          </div>
        </div>

        {/* BENEFICIOS DE GESTIÓN */}
        <div className="gestion-benefits">
          <div className="benefits-container">
            <div className="benefits-header">
              <h2>
                Más que software,
                <span> tranquilidad administrativa</span>
              </h2>
              <p>
                Transformá la gestión administrativa en una ventaja estratégica
                para tu institución.
              </p>
            </div>

            <div className="benefits-features">
              <div className="feature-item">
                <div className="feature-icon">
                  <i className='bx bx-shield-alt'></i>
                </div>
                <div className="feature-content">
                  <h4>Datos protegidos y auditados</h4>
                  <p>
                    Toda la información institucional respaldada con
                    protocolos de seguridad y trazabilidad completa.
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className='bx bx-sync'></i>
                </div>
                <div className="feature-content">
                  <h4>Sincronización en tiempo real</h4>
                  <p>
                    Cambios reflejados instantáneamente en todos los
                    módulos y para todos los usuarios autorizados.
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className='bx bx-trending-up'></i>
                </div>
                <div className="feature-content">
                  <h4>Decisiónes basadas en datos</h4>
                  <p>
                    Reportes y dashboards que transforman información
                    en datos relevantes para la gestión.
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className='bx bx-group'></i>
                </div>
                <div className="feature-content">
                  <h4>Colaboración institucional</h4>
                  <p>
                    Diferentes roles y permisos que facilitan el trabajo
                    en equipo entre áreas administrativas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CIERRE EMOCIONAL */}
        <div className="gestion-closing">
          <div className="closing-container">
            <div className="closing-icon">
              <i className='bx bx-check-shield'></i>
            </div>
            <h3 className="closing-title">
              Menos tareas repetidas.
              <span> Más control, más tiempo y más tranquilidad.</span>
            </h3>
            <p className="closing-text">
              Tresaedu libera a tu institución de la carga administrativa,
              permitiéndote concentrarte en lo educativo.
            </p>

            {/* CTA de gestión */}
            <div className="gestion-cta">
              <a
                href='https://wa.me/message/ORWIOZ4UP74NM1' target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                <i className='bx bx-calendar-check'></i>
                <span>Optimizar la gestión de mi institución</span>
              </a>
              <p className="cta-subtext">
                Demo personalizada sin compromiso
              </p>
            </div>
          </div>
        </div>

      </section>
      <Footer2 />
    </>
  );
}

export default GestionAdministrativa;